import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { id: "inicio", label: "Inicio" },
  { id: "nosotros", label: "Nosotros" },
  { id: "valores", label: "Valores" },
  { id: "servicios", label: "Servicios" },
  { id: "contacto", label: "Contacto" },
];

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b5b811b2-a7ff-452a-9cfa-2f673fde2f06/artifacts/5t2w93oo_Simple%20Solutions.png";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#BFBFBF]/40 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between">
        <button
          data-testid="navbar-logo"
          onClick={() => handleNav("inicio")}
          className="flex items-center gap-3 group"
          aria-label="Ir al inicio"
        >
          <img
            src={LOGO_URL}
            alt="Simple Solutions Asesores"
            className="h-11 w-11 object-contain"
          />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-display font-bold text-[15px] tracking-tight text-black">
              SIMPLE SOLUTIONS
            </span>
            <span className="font-display text-[10px] tracking-[0.35em] text-[#BF1828] mt-0.5">
              ASESORES
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => handleNav(item.id)}
              className="link-underline font-body text-[13px] tracking-[0.15em] uppercase text-black hover:text-[#BF1828] transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="navbar-cta"
          onClick={() => handleNav("contacto")}
          className="hidden lg:inline-flex bg-[#BF1828] text-white hover:bg-black transition-colors px-6 py-3 text-xs uppercase tracking-[0.2em] font-medium"
        >
          Trabajemos Juntos
        </button>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-black p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        data-testid="navbar-mobile-menu"
        className={`lg:hidden absolute top-full left-0 right-0 bg-white border-b border-[#BFBFBF]/40 overflow-hidden transition-all duration-300 ${
          open ? "max-h-[480px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-mobile-link-${item.id}`}
              onClick={() => handleNav(item.id)}
              className="text-left font-body text-sm uppercase tracking-[0.2em] text-black hover:text-[#BF1828] transition-colors"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="navbar-mobile-cta"
            onClick={() => handleNav("contacto")}
            className="mt-2 bg-[#BF1828] text-white hover:bg-black transition-colors px-6 py-3 text-xs uppercase tracking-[0.2em] font-medium w-fit"
          >
            Trabajemos Juntos
          </button>
        </div>
      </div>
    </header>
  );
};
